import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Tooltip from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Tooltip';
import { IconButton } from '@material-ui/core';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('AttachmentHoverMenuItem', (theme) => ({
  root: {},
  hoverMenuButton: {
    padding: 0,
    color: theme.palette.common.white,
    height: '100%',
  },
}));

const AttachmentHoverMenuItem = ({
  className,
  isVisible,
  onClick,
  icon,
  toolTipTitle,
  test,
  disabled,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const handleAttachmentHoverMenuItemOnClick = event => {
    event.stopPropagation(); // <--- Prevents click-through propogation
    onClick();
  };

  const Icon = icon;

  return (
    <div
      className={classnames(classes.root, className)}
    >
      {isVisible && (
        <Tooltip
          placement="top"
          title={toolTipTitle}
        >
          <IconButton
            className={classes.hoverMenuButton}
            onClick={event => handleAttachmentHoverMenuItemOnClick(event)}
            test={test}
            disabled={disabled}
          >
            <Icon />
          </IconButton>
        </Tooltip>
      )}
    </div>
  );
};

AttachmentHoverMenuItem.defaultProps = {
  className: '',
  test: null,
  disabled: false,
};

AttachmentHoverMenuItem.propTypes = {
  className: PropTypes.string,
  isVisible: PropTypes.bool.isRequired,
  toolTipTitle: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  test: PropTypes.string,
};

export { AttachmentHoverMenuItem };
